/** 
  Author: Suneel Singh - suneel.singh@enabledata.com
  Purpose: Procedures services
  Date: may 2020
**/

import API from '../utils/api';
import LocalStorageService from './localStorage';
const localStorageService = LocalStorageService.getService();
// import { globalPageLimit } from '../constants/applicationConstants';

export const getProceduresList = (payload) => {
  let queryString = '?limit=2000';
  if (payload && payload.active && payload.next_page) {
    queryString += `&active=${payload.active}&next_page=${encodeURIComponent(
      JSON.stringify(payload.next_page),
    )}`;
  } else if (payload && payload.active) {
    queryString += `&active=${payload.active}`;
  } else if (payload && payload.next_page) {
    queryString += `&next_page=${encodeURIComponent(
      JSON.stringify(payload.next_page),
    )}`;
  }
  return API.get(`procedures/procedures${queryString}`, {
    headers: {
      Authorization: `Bearer ${localStorageService.getAccessToken()}`,
      'Cache-Control': `max-age=86400`,
      'Accept-Encoding': 'gzip, deflate',
    },
  });
};

export const getProcedures = (id) => {
  return API.get(`procedures/procedures/${id}`, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const addProcedures = (data) => {
  return API.post(`procedures/procedures`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const updateProcedures = (data) => {
  return API.put(`procedures/procedures/${encodeURIComponent(data.PK)}`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};

export const getProcedureProgramAssociation = (payload) => {
  let queryString = '';
  if (payload.lastEvalKeyNew) {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}&lastEvalKeyNew=${encodeURIComponent(JSON.stringify(payload.lastEvalKeyNew))}`;
  } else {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}`
  }
  return API.get(`associations/list-associations/${payload.id}${queryString}`, {
    headers: { Authorization: `Bearer ${LocalStorageService.getAccessToken()}` },
  });
};

export const getProcedureClientAssociation = (payload) => {
  let queryString = '';
  if (payload.lastEvalKeyNew) {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}&lastEvalKeyNew=${encodeURIComponent(JSON.stringify(payload.lastEvalKeyNew))}`;
  } else {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}`
  }
  return API.get(`associations/list-associations/${payload.id}${queryString}`, {
    headers: { Authorization: `Bearer ${LocalStorageService.getAccessToken()}` },
  });
};


export const getProcedureLoBAssociation = (payload) => {
  let queryString = '';
  if (payload.lastEvalKeyNew) {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}&lastEvalKeyNew=${encodeURIComponent(JSON.stringify(payload.lastEvalKeyNew))}`;
  } else {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}`
  }
  return API.get(`associations/list-associations/${payload.id}${queryString}`, {
    headers: { Authorization: `Bearer ${LocalStorageService.getAccessToken()}` },
  });
};

export const getProcedureGroupAssociation = (payload) => {
  let queryString = '';
  if (payload.lastEvalKeyNew) {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}&lastEvalKeyNew=${encodeURIComponent(JSON.stringify(payload.lastEvalKeyNew))}`;
  } else {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}`
  }
  return API.get(`associations/list-associations/${payload.id}${queryString}`, {
    headers: { Authorization: `Bearer ${LocalStorageService.getAccessToken()}` },
  });
};

export const getProcedurePolicyAssociation = (payload) => {
  let queryString = '';
  if (payload.lastEvalKeyNew) {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}&lastEvalKeyNew=${encodeURIComponent(JSON.stringify(payload.lastEvalKeyNew))}`;
  } else {
    queryString = `?entity_type=${payload.type}&association_with=${payload.with}`
  }
  return API.get(`associations/list-associations/${payload.id}${queryString}`, {
    headers: { Authorization: `Bearer ${LocalStorageService.getAccessToken()}` },
  });
};
export const updateProcedureStatus = (data) => {
  return API.post(`settings/patch/procedures`, data, {
    headers: { Authorization: `Bearer ${localStorageService.getAccessToken()}` },
  });
};